<h1 fxLayoutAlign="center">Programmes</h1>

<div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around">

	<div fxFlex="25">
		<mat-card>
			 <img width="100%" src="https://firebasestorage.googleapis.com/v0/b/top-crew.appspot.com/o/TCA-ASSETS%2Fimg_2.webp?alt=media&token=ddef45ae-ffab-4235-97c4-67fb38bd7b3c" alt="">
			<mat-card-title>
				<h3>RTR(A) Ground Classes</h3>
			</mat-card-title>
			<mat-card-content>
			  <ul>
          <li><span>Latest Updated Study Material.</span></li>
          <li><span>Live headphone Training following ICAO standards.</span></li>
          <li><span>Extesive pool of situational Questions to prepare you not just for exam but real life.</span></li>
        </ul>
			</mat-card-content>
		</mat-card>
	</div>
	<div fxFlex="25">
		<mat-card>
		 
      <img width="100%" src="https://firebasestorage.googleapis.com/v0/b/top-crew.appspot.com/o/TCA-ASSETS%2Fimg_1.webp?alt=media&token=be9a1030-79c4-4b5b-9d07-b002922a8e11" alt="">
			<mat-card-title>
			<h3>	CPL / ATPL Ground Classes</h3>
			</mat-card-title>
			<mat-card-content>
				<ul >
          <li><span>Air Navigation</span></li>
          <li><span>Air Regulations</span></li>
          <li><span>Meteorolgy</span></li>
          <li><span>Technical General</span></li>
          <li><span>Technical Specific</span></li>
        </ul>
			</mat-card-content>
		</mat-card>
	</div>

	<div fxFlex="25">
		<mat-card>
      <img width="100%" src="https://firebasestorage.googleapis.com/v0/b/top-crew.appspot.com/o/TCA-ASSETS%2Fimg_3.webp?alt=media&token=f4c6c7ba-ac6e-4859-932c-63864dbcdb78" alt="">
			<mat-card-title>
				<h3>Flying Training</h3>
			</mat-card-title>
			<mat-card-content>
        <ul >
          <li><span>Training from DGCA approved institute in India & Abroad.</span></li>
          <li><span>Expedited but Quality Training following DGCA standards.</span></li>
          <li><span>DGCA Documentation Support.</span></li>
          <li><span>Airline Placement Support.</span></li>
        </ul>
      </mat-card-content>
		</mat-card>
	</div>

</div>